module.exports = __webpack_public_path__ + "static/media/turtle.b459e553.jpg";